import React, { useState, useEffect } from "react";
import Select from "react-select";
import axios from "axios";
import Swal from "sweetalert2";
const EditAdminModal = ({ show, onClose, onSubmit, data }) => {
  const [loms, setLoms] = useState([]);
  const [formData, setFormData] = useState({
    membership_id: "",
    admin_name: "",
    lom_name: "",
    contact_number: "",
    whatsapp_number: "",
    lom_id: 0,
  });
  useEffect(() => {
    console.log(data);
    fetchLoms();
  }, []);
  const fetchLoms = async () => {
    try {
      const response = await axios.get("/lom/read");
      setLoms(response.data);
    } catch (error) {
      console.error("Error fetching LOM Presidents:", error);
    }
  };
  const lomoptions = [
    ...loms.map((lom) => ({
      value: lom.lom_id,
      label: lom.lom_name,
    })),
  ];
  // Populate the form with existing data when the modal opens
  useEffect(() => {
    if (show && data) {
      // Pre-fill the form with event details
      setFormData({
        membership_id: data.membership_id,
        admin_name: data.admin_name,
        lom_name: data.lom_name,
        lom_id: data.lom_id,
        contact_number: data.contact_number,
        whatsapp_number: data.whatsapp_number,
      });
    }
    // if (show && data) {
    //   setFormData(data);
    // }
  }, [show, data]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // PUT request to update event by eventId
      const response = await axios.put(
        `/admin/update/${data.admin_id}`,
        formData
      );
      console.log("Event updated:", response.data);

      Swal.fire({
        icon: "success",
        title: "Admin Updated",
        text: "Admin has been updated successfully!",
        confirmButtonText: "Okay",
      });

      onSubmit(formData); // Pass the updated data to the parent component
      onClose(); // Close the modal
    } catch (err) {
      console.log(err.response?.data?.error || "Failed to update event");
    }
  };
  const handleLomChange = (selected) => {
    console.log("Selected:", typeof selected.value); // Debugging log
    setFormData((prevState) => ({
      ...prevState,
      lom_id: selected ? selected.value : "",
    }));
  };

  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-lg max-w-4xl w-full p-6">
        <h2 className="text-xl font-bold mb-4">Edit Admin</h2>
        <form onSubmit={handleSubmit}>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {/* LOM Name */}
            <div>
              <label className="block text-sm font-medium mb-1">
                LOM Name{typeof data.lom_id}
              </label>
              <Select
                name="lom_name"
                value={lomoptions.find(
                  (option) => option.value === Number(formData.lom_id) // Ensure type matching
                )}
                onChange={handleLomChange}
                options={lomoptions}
                className="w-full p-2 border rounded-lg"
                required
              ></Select>
            </div>
            {/* Year */}
            {/* <div>
              <label className="block text-sm font-medium mb-1">Year</label>
              <input
                type="number"
                name="year"
                value={formData.year}
                onChange={handleChange}
                required
                className="w-full border rounded px-3 py-2"
              />
            </div> */}
            {/* Name */}
            <div>
              <label className="block text-sm font-medium mb-1">
                Admin Name
              </label>
              <input
                type="text"
                name="admin_name"
                value={formData.admin_name}
                onChange={handleChange}
                required
                className="w-full border rounded px-3 py-2"
              />
            </div>
            {/* Member ID */}
            <div>
              <label className="block text-sm font-medium mb-1">
                MemberShip ID
              </label>
              <input
                type="text"
                name="membership_id"
                value={formData.membership_id}
                onChange={handleChange}
                required
                className="w-full border rounded px-3 py-2"
              />
            </div>
            {/* Contact Number */}
            <div>
              <label className="block text-sm font-medium mb-1">
                Contact Number
              </label>
              <input
                type="text"
                name="contact_number"
                value={formData.contact_number}
                onChange={handleChange}
                required
                className="w-full border rounded px-3 py-2"
              />
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">
                Whatsapp Number
              </label>
              <input
                type="text"
                name="whatsapp_number"
                value={formData.whatsapp_number}
                onChange={handleChange}
                required
                className="w-full border rounded px-3 py-2"
              />
            </div>
          </div>
          <div className="flex justify-end mt-4">
            <button
              type="button"
              onClick={onClose}
              className="bg-gray-300 text-black px-4 py-2 rounded mr-2"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="bg-blue-500 text-white px-4 py-2 rounded"
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditAdminModal;
